import { render, staticRenderFns } from "./ModalAlertSetting.vue?vue&type=template&id=152dd12d"
import script from "./ModalAlertSetting.vue?vue&type=script&lang=js"
export * from "./ModalAlertSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports